// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: 262487938
// </auto-generated>
import {
  StringLength,
  RegularExpression,
  Required,
  EmailAddress,
  MinValue,
} from 'carehub-shared/validators';

export class Activity {
  @Required()
  activityId: string;
  @Required()
  memberId: string;
  memberCaseId: string;
  activityDirectionId: number;
  activityReasonId: number;
  activityTypeId: number;
  activityWithId: number;
  @Required()
  activityDate: Date | string;
  description: string;
  @StringLength(50)
  reference: string;
  inactiveDate: Date | string;
  createdUserId: string;
  updatedUserId: string;
  createdDate: Date | string;
  updatedDate: Date | string;
  activitySubTypeId: number;
  activityRelatedToId: number;
}

export function initializeNewActivity(): Activity {
  const instance = new Activity();
  instance.activityId = '00000000-0000-0000-0000-000000000000';
  instance.memberId = '00000000-0000-0000-0000-000000000000';
  instance.memberCaseId = '00000000-0000-0000-0000-000000000000';
  instance.activityDirectionId = null;
  instance.activityReasonId = null;
  instance.activityTypeId = null;
  instance.activityWithId = null;
  instance.activityDate = null;
  instance.description = '';
  instance.reference = '';
  instance.inactiveDate = null;
  instance.createdUserId = '00000000-0000-0000-0000-000000000000';
  instance.updatedUserId = '00000000-0000-0000-0000-000000000000';
  instance.createdDate = null;
  instance.updatedDate = null;
  instance.activitySubTypeId = null;
  instance.activityRelatedToId = null;
  return instance;
}
